setTimeout(function() {
    (function (factory) {
        // Browser globals
        factory(jQuery.datepicker);
    }(function (datepicker) {
        datepicker.regional = {
            closeText: Localization.getString('Datepicker.Close', 'Закрыть'),
            prevText: "",
            nextText: "",
            currentText: Localization.getString('Datepicker.Today', 'Сегодня'),
            monthNames: [
                Localization.getString('Datepicker.January', 'Январь'),
                Localization.getString('Datepicker.February', 'Февраль'),
                Localization.getString('Datepicker.March', 'Март'),
                Localization.getString('Datepicker.April', 'Апрель'),
                Localization.getString('Datepicker.May', 'Май'),
                Localization.getString('Datepicker.June', ''),
                Localization.getString('Datepicker.July', ''),
                Localization.getString('Datepicker.August', ''),
                Localization.getString('Datepicker.September', ''),
                Localization.getString('Datepicker.October', ''),
                Localization.getString('Datepicker.November', ''),
                Localization.getString('Datepicker.December', '')
            ],
            monthNamesShort: [
                Localization.getString('Datepicker.JanuaryShort', 'Янв'),
                Localization.getString('Datepicker.FebruaryShort', 'Фев'),
                Localization.getString('Datepicker.MarchShort', 'Мар'),
                Localization.getString('Datepicker.AprilShort', 'Апр'),
                Localization.getString('Datepicker.MayShort', 'Май'),
                Localization.getString('Datepicker.JuneShort', 'Июн'),
                Localization.getString('Datepicker.JulyShort', 'Июл'),
                Localization.getString('Datepicker.AugustShort', 'Авг'),
                Localization.getString('Datepicker.SeptemberShort', 'Сен'),
                Localization.getString('Datepicker.OctoberShort', 'Окт'),
                Localization.getString('Datepicker.NovemberShort', 'Ноя'),
                Localization.getString('Datepicker.DecemberShort', 'Дек')],
            dayNames: [
                Localization.getString('Datepicker.Sunday', 'Воскресенье'),
                Localization.getString('Datepicker.Monday', 'Понедельник'),
                Localization.getString('Datepicker.Tuesday', 'Вторник'),
                Localization.getString('Datepicker.Wednesday', 'Среда'),
                Localization.getString('Datepicker.Thursday', 'Четверг'),
                Localization.getString('Datepicker.Friday', 'Пятница'),
                Localization.getString('Datepicker.Saturday', 'Суббота')
            ],
            dayNamesShort: [
                Localization.getString('Datepicker.SundayShort', 'вск'),
                Localization.getString('Datepicker.MondayShort', 'пнд'),
                Localization.getString('Datepicker.TuesdayShort', 'втр'),
                Localization.getString('Datepicker.WednesdayShort', 'срд'),
                Localization.getString('Datepicker.ThursdayShort', 'чтв'),
                Localization.getString('Datepicker.FridayShort', 'птн'),
                Localization.getString('Datepicker.SaturdayShort', 'сбт')
            ],
            dayNamesMin: [
                Localization.getString('Datepicker.SundayMin', 'Вс'),
                Localization.getString('Datepicker.MondayMin', 'Пн'),
                Localization.getString('Datepicker.TuesdayMin', 'Вт'),
                Localization.getString('Datepicker.WednesdayMin', 'Ср'),
                Localization.getString('Datepicker.ThursdayMin', 'Чт'),
                Localization.getString('Datepicker.FridayMin', 'Пт'),
                Localization.getString('Datepicker.SaturdayMin', 'Сб')
            ],
            weekHeader: Localization.getString('Datepicker.WeekShort','Нед'),
            dateFormat: Localization.getString('Datepicker.DateFormat','dd.mm.yy'),
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ""
        };
        datepicker.setDefaults(datepicker.regional);

        return datepicker.regional;

    }));
}, 250);